import { useFormContext } from "react-hook-form";
import ToggleButtonUI from "./ToggleButtonUI";

type PropsType = {
  section?: string;
  name: string;
  leftOption: {
    label: string;
    value: string;
  };
  rightOption: {
    label: string;
    value: string;
  };
  className?: string;
  readOnly?: boolean;
};
const ToggleButton = ({
  section,
  name,
  leftOption,
  rightOption,
  className,
  readOnly,
}: PropsType) => {
  const { register, watch } = useFormContext();

  const nameDotFormat = (() => {
    if (section) {
      return `${section}.${name}`;
    }
    return `${name}`;
  })();

  const inputProps = register(nameDotFormat);

  return (
    <ToggleButtonUI
      value={watch(nameDotFormat)}
      leftOption={{ inputProps, ...leftOption }}
      rightOption={{ inputProps, ...rightOption }}
      className={className}
      readOnly={readOnly}
    />
  );
};

export default ToggleButton;
